function initRelatedCarousel(){
    "use strict";

    $('#related-carousel').slick({
		dots: false,
		arrows: true,
		nav: false,
		infinite: true,
		speed: 300,
		slidesToShow: 2,
		slidesToScroll: 1,
		prevArrow: PREV_ARROW,
		nextArrow: NEXT_ARROW,
		appendArrows:'.news-navigation',
		responsive: [
		    {
				breakpoint: 768,
				settings: {
					slidesToShow: 1,					
				}
		    },
    	]
		
	});



}
function initNewsWaypoints(){
	   $('.news-point-animate').addClass( "way-point-ready");

	 $('.news-point-animate').waypoint(function(direction) {
            $(this.element).addClass('shown');
        }, {
            offset: '95%'
        });

}

